/*
 * vrtClaim.us
 * vue router: Claim
 *
 */
import type { RouteRecordRaw } from 'vue-router';
//
const vrtClaim: RouteRecordRaw = {
  path: '/eservices/claim',
  name: 'vrtClaim',
  component: () => import('src/layouts/vcleSystem.vue'),
  children: [
    {
      path: 'view',
      name: 'vrtClaimList',
      component: () => import('./vpgClaimList.vue'),
    },
    {
      path: 'update',
      name: 'vrtClaimUpdate',
      component: () => import('./vpgClaimUpdate.vue'),
    },
    {
      path: 'create',
      name: 'vrtClaimCreate',
      component: () => import('./vpgClaimCreate.vue'),
    },
    {
      path: 'details',
      name: 'vrtClaimDetails',
      component: () => import('./vpgClaimDetails.vue'),
    },
    {
      path: 'detailsold',
      name: 'vrtClaimDetailsOld',
      component: () => import('./vpgClaimDetailsOld.vue'),
    },
    {
      path: 'report',
      name: 'vrtClaimReport',
      component: () => import('./vpgClaimReport.vue'),
    },
    {
      path: 'release',
      name: 'vrtClaimRelease',
      component: () => import('./vpgClaimRelease.vue'),
    },
  ],
};
//
export default vrtClaim;
//#end#
